/*
    OneQuickShop 2.0.0 Usage (Webpack)
    yang @onerockwell        
*/

// Import all dependencies here
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import OneSwatches from 'Modules/module-oneSwatches';

// Define the Backbone View here (Optional)
let OneQuickShopView = Backbone.View.extend({
	
    initialize: function (settings) {
        console.log('init quickshop');
        var self = this;
        self.$productGrid = self.$el.find('.collection-products');
        self.$products = self.$productGrid.find('.item');
        self.isProductPage = settings.isProductPage || false;
        self.isInitialized = false;

        self.quickShopModal();

        setTimeout(function(){
            self.quickbuy();
        }, 1000);
    },

    events: {
        
    },
    
    quickShopModal: function(){
        var self = this;

        var quickBuyDialog = function(e){
            var $currentContainer = $(e.currentTarget).parents('.item').first();
            var $currentQuickBuy = $currentContainer.find('.quickshop-module');
            var $quickBuyMedia = $currentQuickBuy.find('.product-media');

            // $quickBuyMedia.find('img').each(function(i,ele){
            //     $(ele).attr('src',$(ele).data('src'));
            // });

            if($quickBuyMedia.attr('class').indexOf('slick-initialized') < 1){
                $quickBuyMedia.slick({
                    dots: false,
                    infinite: true,
                    speed: 600,
                    slidesToShow: 1,
                    arrows: true,
                    lazyLoad: 'progressive'
                });
            }
            
            var $variantContainer = $currentContainer.find('.selector-wrapper > .swatches').first();
            if($variantContainer.find('li').length < 2){
                console.log('preselect variant');
                $variantContainer.find('li').first().trigger('click');
            }

            $currentQuickBuy.addClass('active');

        }
        
        var events = {
            'click .item .quick-buy' : quickBuyDialog,
            'click .quickshop-module .close' : function(e){
                $(e.currentTarget).parents('.quickshop-module ').removeClass('active');
            },
            'click .quickshop-module': function(e){
                if ($(e.target).parents('.quickshop-wrapper').length < 1) {
                    $(e.currentTarget).removeClass('active');
                }
            },
            'click .add-to-cart-btn:not(.disabled)': function(e){
                var $addToCartBtn = $(e.currentTarget);
                var originalCaption = $addToCartBtn.find('.add-to-cart-text').text();
                $addToCartBtn.find('.add-to-cart-text').addClass('added').text('Added to bag');

                setTimeout(function(){
                    $addToCartBtn.parents('.quickshop-module ').removeClass('active');
                },1500);
                setTimeout(function(){
                    $addToCartBtn.find('.add-to-cart-text').removeClass('added').text(originalCaption);
                },6000);
            }
        };
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    quickbuy: function () {
        var self = this;
        
        console.log("LENGTH: " + $('.item').find('.quickshop-module').length);
        var events = {
            'click .quick-buy' : function(e){
                var $product = $(e.currentTarget).parents('.item');
                if ($product.find('.quickshop-module').length) {
                    var $form = $product.find('form'),
                    onesize = $form.hasClass('onesize'),
                    pid = $product.data('id'),
                    pdata = $product.find('[data-product-json]').length ? JSON.parse($product.find('[data-product-json]').html()) : false;

                    if (self.isProductPage === true) {
                        $product.find('.quickshop-module').find('.product-select-wrapper').find('.selector-wrapper').remove();
                    }
                    new Shopify.OptionSelectors('productSelect-' + pid, {
                        product: pdata,
                        onVariantSelected: ShopifyAPI.selectCallback,
                        enableHistoryState: false
                    });
                    self.isInitialized = true;
                    OneSwatches.init({ el: $product, preSelect: onesize, product: pdata, isProductPage: self.isProductPage });
                    
                    $product.find('.quickshop-module').addClass('initialized');
                }
            }
        };
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    destroy: function() {
        var self = this;
        self.undelegateEvents();
    }

});

// Define the module here 
let OneQuickShop = {
    init: function (settings) {
        if (!settings.el) {
            settings.el = $('body');
        }
        return new OneQuickShopView(settings);
    }
}

// Output the module
export default OneQuickShop;